"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RedirectUrls = /** @class */ (function () {
    function RedirectUrls() {
    }
    //Teams app for join
    RedirectUrls.teamsAppForJoin = "msteams:";
    //Join for browser
    RedirectUrls.browserForJoin = "https://teams.microsoft.com";
    return RedirectUrls;
}());
exports.default = RedirectUrls;
//# sourceMappingURL=redirect-urls.js.map